import AX_INSTRUCTIONS_ACTION from '../enums/axInstructionsActions'
import AX_INSTRUCTIONS_STATUS from '../enums/axInstructionsStatus'
import AX_INSTRUCTIONS_STEPS from '../enums/axInstructionsSteps'

const steps = [
    {
        name: AX_INSTRUCTIONS_STEPS.INSTRUCTIONS,
        status: AX_INSTRUCTIONS_STATUS.CURRENT,
    },
    {
        name: AX_INSTRUCTIONS_STEPS.KALVIUM_HONOUR_CODE,
        status: AX_INSTRUCTIONS_STATUS.PENDING,
    },
    {
        name: AX_INSTRUCTIONS_STEPS.DETAILS_FORM,
        status: AX_INSTRUCTIONS_STATUS.PENDING,
    },
    {
        name: AX_INSTRUCTIONS_STEPS.SETUP_TEST_ENVIRONMENT,
        status: AX_INSTRUCTIONS_STATUS.PENDING,
    },
]

export const initialState = {
    assessment: {},
    currentStep: 0,
    totalSteps: steps.length,
    steps,
    formValues: {
        name: '',
        email: '',
        mobileNumber: '',
        schoolName: '',
    },
    abideHonourCode: false,
    attempts: [],
    otp: '',
    retryEnabled: false,
    fullScreenExitState:''
}

export const reducer = (state, action) => {
    switch (action.type) {
        case AX_INSTRUCTIONS_ACTION.NEXT_STEP: {
            const totalSteps = state.totalSteps
            const currentStep = state.currentStep
            if (currentStep + 1 >= totalSteps) {
                return state
            }
            const newState = { ...state }
            const newStep = currentStep + 1

            // mark the current step as completed
            newState.steps[currentStep].status =
                AX_INSTRUCTIONS_STATUS.COMPLETED

            // mark the new step as current
            newState.steps[newStep].status = AX_INSTRUCTIONS_STATUS.CURRENT

            // move to next step
            newState.currentStep = newStep

            return newState
        }

        case AX_INSTRUCTIONS_ACTION.PREV_STEP: {
            const currentStep = state.currentStep
            if (currentStep - 1 < 0) {
                return state
            }
            const newState = { ...state }
            const newStep = currentStep - 1

            // mark the current step as pending
            newState.steps[currentStep].status = AX_INSTRUCTIONS_STATUS.PENDING

            // mark the previouse step as current
            newState.steps[newStep].status = AX_INSTRUCTIONS_STATUS.CURRENT

            // move to previous step
            newState.currentStep = newStep
            return newState
        }

        case AX_INSTRUCTIONS_ACTION.UPDATE_FORM: {
            const newValues = { ...action.values }
            return { ...state, formValues: newValues }
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_ATTEMPTS: {
            const newAttempts = action.attempts
            return { ...state, attempts: [...newAttempts] }
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_CURRENT_STEP_STATUS: {
            const currentStepIdx = state.currentStep
            const newState = { ...state }
            newState.steps[currentStepIdx].status = action.status
            return newState
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_OTP: {
            const newState = { ...state }
            newState.otp = action.otp
            return newState
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_ABIDE_HONOUR_CODE: {
            return { ...state, abideHonourCode: action.value }
        }

        case AX_INSTRUCTIONS_ACTION.UPDATE_RETRY_ENABLED: {
            return { ...state, retryEnabled: action.value }
        }

        case AX_INSTRUCTIONS_ACTION.UPDATE_ASSESSMENT: {
            return { ...state, assessment: action.payload }
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_STEPS: {
            const newSteps = action.payload
            return { ...state, totalSteps: newSteps.length, steps: newSteps }
        }
        case AX_INSTRUCTIONS_ACTION.UPDATE_CHALLENGE: {
            return { ...state, challenge: action.value }
        }
         case AX_INSTRUCTIONS_ACTION.SET_FULL_SCREEN_EXIT_STATE: {
            return { ...state , fullScreenExitState : action.value }
         }
    }
}
